// extracted by mini-css-extract-plugin
module.exports = {"Background":"Header_Background__2hWFy","Title":"Header_Title__3TqbF","Img":"Header_Img__1Dj2z"};